export default "__VITE_ASSET__9cb3e286__"